<template>
  <!-- 加班审批 -->
  <div>
    <Collapse v-model="value2" simple :disabled="prevent" style="border: 0">
      <Panel name="1" hide-arrow style="margin-bottom: 20px; border: 0">
        <FormTitle
          :titleText="
            lang == 'zh' ? chName.BasicInformation : enName.BasicInformation
          "
        />
        <Form
          slot="content"
          :label-width="150"
          label-position="left"
          class="titleDistance"
          :disabled="prevent"
          style="margin-top: 40px"
        >
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="lang == 'zh' ? chName.createTime : enName.createTime"
              >
                <Input disabled v-model="formItem.applyDate" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="lang == 'zh' ? chName.applyNo : enName.applyNo">
                <Input disabled v-model="formItem.applyNo" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7"> </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="lang == 'zh' ? chName.applyName : enName.applyName"
              >
                <Input disabled v-model="formItem.userName" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="lang == 'zh' ? chName.applyUserId : enName.applyUserId"
              >
                <Input disabled v-model="formItem.applyUserId" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="
                  lang == 'zh' ? chName.applyPosition : enName.applyPosition
                "
              >
                <Input disabled v-model="formItem.positionName" />
              </FormItem>
            </Col>
          </Row>
          <!-- <Row type="flex" justify="space-between">
                <Col :xs="24" :sm="24" :md="24" :lg="7">
                  <FormItem label="公司">
                     <Input disabled v-model="formItem.orgsname2"/>
                  </FormItem>
                </Col>                
                <Col :xs="24" :sm="24" :md="24" :lg="7">
                  <FormItem label="地区">
                     <Input disabled v-model="formItem.orgsname4"/>
                  </FormItem>
                </Col>
                <Col :xs="24" :sm="24" :md="24" :lg="7">
                  <FormItem label="部门">
                    <Input disabled v-model="formItem.orgsname5"/>
                  </FormItem>
                </Col>
            </Row>  -->
        </Form>
      </Panel>
      <Panel name="2" hide-arrow style="margin-bottom: 20px; border: 0">
        <FormTitle
          :titleText="
            lang == 'zh'
              ? chName.OvertimeApplicationInformation
              : enName.OvertimeApplicationInformation
          "
        />
        <Form
          slot="content"
          :label-width="150"
          label-position="left"
          class="titleDistance"
        >
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="lang == 'zh' ? chName.p_begin_dt : enName.p_begin_dt"
                prop="p_begin_dt"
              >
                <DatePicker
                  :editable="false"
                  :options="options1"
                  type="date"
                  v-model="formItem.p_begin_dt"
                  disabled
                  style="width: 100%"
                ></DatePicker>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="lang == 'zh' ? chName.p_begin_tm : enName.p_begin_tm"
              >
                <TimePicker
                  :editable="false"
                  format="HH:mm"
                  :steps="[1, 30]"
                  v-model="formItem.p_begin_tm"
                  disabled
                  style="width: 100%"
                ></TimePicker>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="lang == 'zh' ? chName.otType : enName.otType">
                <Select
                  v-model="formItem.otType1"
                  :clearable="true"
                  placeholder=""
                  disabled
                >
                  <Option
                    :value="item.code"
                    v-for="(item, i) in overTimeTypeList"
                    :key="i"
                    >{{ item.name }}
                  </Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="lang == 'zh' ? chName.p_end_dt : enName.p_end_dt"
              >
                <DatePicker
                  :editable="false"
                  :options="options1"
                  type="date"
                  v-model="formItem.p_end_dt"
                  disabled
                  style="width: 100%"
                ></DatePicker>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="lang == 'zh' ? chName.p_end_tm : enName.p_end_tm"
              >
                <TimePicker
                  :editable="false"
                  format="HH:mm"
                  :steps="[1, 30]"
                  v-model="formItem.p_end_tm"
                  disabled
                  style="width: 100%"
                ></TimePicker>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="lang == 'zh' ? chName.otType : enName.otType">
                <Select
                  v-model="formItem.otType1"
                  :clearable="true"
                  placeholder=""
                  disabled
                >
                  <Option
                    :value="item.code"
                    v-for="(item, i) in overTimeTypeList"
                    :key="i"
                    >{{ item.name }}
                  </Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="
                  lang == 'zh' ? chName.overTimeLength : enName.overTimeLength
                "
              >
                <Input v-model="formItem.overTimeLength" disabled />
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col span="24">
              <FormItem
                span="3"
                :label="lang == 'zh' ? chName.nvchr1 : enName.nvchr1"
              >
                <Input type="textarea" v-model="formItem.nvchr1" disabled />
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Panel>
      <Panel name="3" hide-arrow style="margin-bottom: 20px; border: 0">
        <FormTitle
          :titleText="
            lang == 'zh'
              ? chName.actualCardSwipingInformation
              : enName.actualCardSwipingInformation
          "
        />
        <Table
          height="300"
          slot="content"
          border
          :columns="punishmentColumns"
          :data="punishmentData"
          class="titleDistance"
        >
          <!-- <template slot-scope="{row}" slot="action">{{date.dateVal(row.card_dt,"YYYY-MM-DD")}}</template>
            <template slot-scope="{row}" slot="action1">{{date.dateVal(row.card_tm,"HH:mm")}}</template>
            <template slot-scope="{row}" slot="action2">
              {{row.daka_type == '0' ? $t('OverTimeApproval.clockIn'): row.daka_type == '1' ? $t('OverTimeApproval.clockOut'): row.daka_type == '2' ? $t('OverTimeApproval.clockInOvertime'): row.daka_type == '3' ? $t('OverTimeApproval.clockOutOvertime') : ""}}</template> -->
        </Table>
        <div
          slot="content"
          style="display: flex;margin: 10px 30px 0 0;justify-content: flex-end;"
        >
          <Page :total="total" @on-change="pageChange" />
        </div>
      </Panel>
    </Collapse>
    <Row class="btnRight">
      <Col>
        <Button
          v-if="!getQueryVariable('history')"
          class="applyBtnRight"
          @click="submitBtn"
          >{{ lang == "zh" ? chName.agree : enName.agree }}</Button
        >
        <Button
          v-if="!getQueryVariable('history')"
          class="applyBtnRight"
          @click="returnThelastonePage"
          >{{ lang == "zh" ? chName.reject : enName.reject }}</Button
        >
        <Button class="applyBtnRight" @click="returnPage()">{{
          lang == "zh" ? chName.return : enName.return
        }}</Button>
      </Col>
    </Row>
    <!-- 审批历史 -->
    <div
      style="margin-bottom: 20px; border: 0"
      v-if="getQueryVariable('history')"
    >
      <FormTitle
        :titleText="
          lang == 'zh' ? chName.approvalhistory : enName.approvalhistory
        "
        style="margin-top: 30px; margin-left: 10px"
      />
      <Table
        border
        :columns="columns1"
        :data="data1"
        slot="content"
        class="titleDistance"
      >
      </Table>
    </div>
    <!-- 审批意见弹窗 -->
    <Modal
      v-model="showdataAgree"
      :title="lang == 'zh' ? chName.approvalopinion : enName.approvalopinion"
      width="500"
      :mask-closable="false"
    >
      <Input v-model="rejectMessage.message" type="textarea" :rows="5"></Input>
      <div slot="footer">
        <Button @click="yess1">{{
          lang == "zh" ? chName.confirm : enName.confirm
        }}</Button>
        <Button @click="cancell1">{{
          lang == "zh" ? chName.cancel : enName.cancel
        }}</Button>
      </div>
    </Modal>
    <Modal
      v-model="showdataRejected"
      :title="lang == 'zh' ? chName.rejectopinion : enName.rejectopinion"
      width="500"
      :mask-closable="false"
    >
      <Form :rules="ruleValidate" :model="rejectMessage" ref="rejectMessage">
        <FormItem prop="message">
          <Input
            v-model="rejectMessage.message"
            type="textarea"
            :rows="5"
          ></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="yess2">{{
          lang == "zh" ? chName.confirm : enName.confirm
        }}</Button>
        <Button @click="cancell2">{{
          lang == "zh" ? chName.cancel : enName.cancel
        }}</Button>
      </div>
    </Modal>
    <Spin size="large" fix v-if="spinShow"></Spin>
  </div>
</template>
<script>
import axios from "axios";
import DateUtil from "../../../util/DateUtil";
export default {
  data() {
    return {
      options1: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000;
        }
      },
      date: new DateUtil(),
      value2: [1, 2, 3],
      formItem: {
        status: ""
      },
      prevent: false,
      isOverdue: false,
      showdataAgree: false, //审批意见
      showdataRejected: false, //驳回意见
      data1: [],
      rejectMessage: {},
      overTimeTypeList: [{ name: "工作日加班", code: "1" }],
      // applyTypeList:[{name:'正常申请',code:'1'},{name:'过期补申请',code:'0'}],
      isHistory: false,
      spinShow: false,
      p_begin_tm: "",
      p_end_tm: "",
      punishmentData: [],
      pageInfo: {
        itemCount: 0,
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      chName: {},
      enName: {}
    };
  },
  created() {
    if (this.getQueryVariable("history")) {
      this.isHistory = true;
    }
    // 查询国际化
    this.getInternation();
  },
  computed: {
    //国际化监听
    lang() {
      return this.$store.getters.selectLangeData;
    },
    ruleValidate() {
      return {
        message: [
          {
            required: true,
            message:
              this.lang == "zh"
                ? this.chName.rejectopinion
                : this.enName.rejectopinion + "！"
          }
        ]
      };
    },
    columns1() {
      return [
        {
          title:
            this.lang == "zh" ? this.chName.stepName : this.enName.stepName,
          key: "stepName",
          align: "center",
          width: "280"
        },
        {
          title:
            this.lang == "zh"
              ? this.chName.approvalperson
              : this.enName.approvalperson,
          key: "userName",
          align: "center",
          width: "280"
        },
        {
          title:
            this.lang == "zh"
              ? this.chName.approvaltime
              : this.enName.approvaltime,
          key: "time",
          align: "center",
          width: "280",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.time, "YYYY-MM-DD HH:mm")
            );
          }
        },
        {
          title:
            this.lang == "zh"
              ? this.chName.approvalstatus
              : this.enName.approvalstatus,
          key: "status",
          align: "center",
          width: "280",
          render: (h, params) => {
            return h(
              "span",
              params.row.status == "0"
                ? "通过"
                : params.row.status == "1"
                ? "驳回"
                : ""
            );
          }
        },
        {
          title:
            this.lang == "zh"
              ? this.chName.approvalopinions
              : this.enName.approvalopinions,
          key: "message",
          align: "center",
          width: "465"
        }
      ];
    },
    punishmentColumns() {
      return [
        {
          title: this.lang == "zh" ? this.chName.date : this.enName.date,
          key: "date",
          align: "center"
        },
        {
          title:
            this.lang == "zh" ? this.chName.workhourid : this.enName.workhourid,
          key: "workhourid",
          align: "center"
        },
        {
          title: this.lang == "zh" ? this.chName.inorout : this.enName.inorout,
          key: "inorout",
          align: "center",
          render: (h, params) => {
            return h(
              "span",
              params.row.inorout == "1"
                ? "出"
                : params.row.inorout == "0"
                ? "进"
                : null
            );
          }
        },
        {
          title: this.lang == "zh" ? this.chName.time : this.enName.time,
          key: "time",
          align: "center"
        }
      ];
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    getInternation() {
      let Obj = {
        viewType: "Over_Time_Apply",
        beUsed: "1"
      };
      this.spinShow = true;
      axios.post("/International/applySelectViewSet", Obj).then(res => {
        console.log(res);
        this.chName = res.data[0];
        this.enName = res.data[1];
        // console.log(this.chName)
        this.spinShow = false;
      });
    },
    getData() {
      let arr1 = {
        instanceId: this.getQueryVariable("instanceId"),
        pageNo: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize
      };
      this.spinShow = true;
      axios.post("/overTime/selectOverTimeData", arr1).then(res1 => {
        this.spinShow = false;
        if (res1) {
          this.data1 = res1.logMap;
          res1.tableInfo.data.data.forEach(item => {
            if (item.att_datetime) {
              item.att_datetime = this.date.dateVal(
                item.att_datetime,
                "YYYY-MM-DD HH:mm"
              );
              item.date = item.att_datetime.slice(0, 10);
              item.time = item.att_datetime.slice(12);
            }
          });
          this.punishmentData = res1.tableInfo.data.data;
          this.total = Number(res1.tableInfo.data.pageInfo.total);
          this.formItem = res1.basicInfo;
          this.formItem.applyDate = this.date.dateVal(
            res1.basicInfo.createTime,
            "YYYY-MM-DD"
          );
          this.$set(this.formItem, "p_begin_dt", res1.basicInfo.pbeginDt);
          this.$set(
            this.formItem,
            "p_begin_tm",
            this.date.dateVal(res1.basicInfo.pbeginTm, "HH:mm")
          );
          this.$set(this.formItem, "p_end_dt", res1.basicInfo.pendDt);
          this.$set(
            this.formItem,
            "p_end_tm",
            this.date.dateVal(res1.basicInfo.pendTm, "HH:mm")
          );
          this.$forceUpdate();
          let obj = {
            serialnumber: res1.basicInfo.applySerialnumber
          };
          axios.post("/overTime/selectOverTimeUser", obj).then(res => {
            if (res) {
              this.$set(this.formItem, "userName", res.userName);
              this.$set(this.formItem, "positionName", res.positionName);
              this.$set(this.formItem, "orgsname2", res.orgsname2);
              this.$set(this.formItem, "orgsname4", res.orgsname4);
              this.$set(this.formItem, "orgsname5", res.orgsname5);
            }
          });
        }
      });
    },
    pageChange() {
      this.pageInfo.pageNum = val;
    },
    handle() {},
    submitBtn() {
      this.showdataAgree = true;
    },
    yess1() {
      this.showdataAgree = false;
      this.spinShow = true;
      // this.p_begin_tm = this.date.dateVal(this.formItem.p_begin_dt1, "YYYY-MM-DD") + " " + this.formItem.p_begin_tm1
      // this.p_end_tm = this.date.dateVal(this.formItem.p_end_dt1, "YYYY-MM-DD") + " " + this.formItem.p_end_tm1
      let arr1 = {
        instanceId: this.getQueryVariable("instanceId"),
        // nvchr1:this.formItem.nvchr11,
        // nvchr2:this.formItem.nvchr21,
        // otType1:this.formItem.overTimeType1,
        // pBeginDt:this.date.dateVal(this.formItem.p_begin_dt1,"YYYY-MM-DD"),
        // pEndDt:this.date.dateVal(this.formItem.p_end_dt1,"YYYY-MM-DD"),
        pBeginTm: this.date.dateVal(this.p_begin_tm, "YYYY-MM-DD HH:mm"),
        pEndTm: this.date.dateVal(this.p_end_tm, "YYYY-MM-DD HH:mm")
      };
      axios.post("/overTime/updaterOverTimeData", arr1).then(res => {
        let arr2 = [
          {
            objData1: { approval_result: "0" },
            stringData1: this.getQueryVariable("taskId"),
            stringData2: this.rejectMessage.message,
            type: "B17"
          }
        ];
        axios.post("/process/execute", arr2).then(res => {
          this.spinShow = false;
          if (res) {
            this.$Message.info(this.$t("Approval_Completed"));
            this.$router.push(
              "/27B8ABB6F63EFBBEF7BD77EC1FE93AE8D5AC2804BF5BD5A1/A3FFBEBFDB713E27"
            );
          }
        });
      });
    },
    cancell1() {
      this.showdataAgree = false;
    },
    yess2() {
      this.$refs["rejectMessage"].validate(valid => {
        if (valid) {
          let arr = [
            {
              objData1: { approval_result: "1" },
              stringData1: this.getQueryVariable("taskId"),
              stringData2: this.rejectMessage.message,
              type: "B17"
            }
          ];
          this.showdataRejected = false;
          this.spinShow = true;
          axios.post("/process/execute", arr).then(res => {
            this.spinShow = false;
            this.prevent = false;
            if (res) {
              this.$Message.info(this.$t("审批驳回成功"));
              this.$router.push(
                "/27B8ABB6F63EFBBEF7BD77EC1FE93AE8D5AC2804BF5BD5A1/A3FFBEBFDB713E27"
              );
            }
          });
        }
      });
    },
    cancell2() {
      this.showdataRejected = false;
    },
    returnThelastonePage() {
      this.showdataRejected = true;
    },
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    },
    returnPage() {
      if (this.isHistory) {
        this.$router.push(
          "/3911E071298B94E27537586515457CF2BA610C6A6F738319/A3FFBEBFDB713E27"
        );
      } else {
        this.$router.push("/27B8ABB6F63EFBBE75D07D383A598492/A3FFBEBFDB713E27");
      }
    }
  }
};
</script>

<style scoped>
.titleDistance {
  margin: 30px 30px 0 30px;
}
.ivu-input-search {
  cursor: pointer;
  padding: 0 16px !important;
  color: #000 !important;
  background: #f8f8f9 !important;
  border-color: #dcdee2 !important;
  transition: all 0.2s ease-in-out;
  position: relative;
  z-index: 2;
}
</style>



// WEBPACK FOOTER //
// src/components/process/Apply/OverTimeApproval.vue